import * as yup from 'yup';

const badgeModalValidation = yup.object().shape({
  badgeTitle: yup.string().trim().required('Title is a required field'),
  badgeDescription: yup.string().trim().required('Description is a required field'),
  badgeImgUrl: yup.string().trim().required('Image is a required field'),
});
export default badgeModalValidation;
